import React from 'react'
import { useMatchScreen } from '../../../context/MatchScreenContext'
import { useAdTier, type AdTier } from '../../../hooks/useAdTier'
import { AdSlots } from './AdSlots'
import { AdsHeading } from './AdsHeading'
import '../../styles/AdsModule/AdsModule.scss'

interface AdsModuleProps {
  adTier?: AdTier
}

export const AdsModule = ({ adTier }: AdsModuleProps) => {
  const { dynamicTargeting } = useMatchScreen()
  const tierName = useAdTier(adTier)

  if (!tierName) {
    return null
  }

  return <div className="ads-module">
      <AdsHeading />
      <AdSlots tierName={tierName} dynamicTargeting={dynamicTargeting} />
    </div>
}
